import React from 'react';

function NotAuthorized() {
  return (
    <div className="modern-container" style={{ paddingTop: 80 }}>
      <div className="modern-card" style={{ maxWidth: 560, margin: '0 auto' }}>
        <h1 className="modern-title">Not authorized</h1>
        <p className="modern-subtitle">You do not have access to the admin console.</p>
      </div>
    </div>
  );
}

export default NotAuthorized;


